
define('eteration/widgets/ui-booker-datepicker',[
	'jquery',
	'knockout',
	'eteration/eteration',
	'eteration/widgets/widget-util',
	'eteration/eteration-i18n',
	'eteration/widgets/ui-common',
	'eteration/widgets/ui-datepicker',
	'eteration/widgets/ui-routerestrictionmessage'
	], 
	function($,ko,Eteration,widgetUtil,i18n){
		
	widgetUtil.setupStringBasedTemplate(ko);
	
	
	ko.components.register('bookerdatepicker', {
	    viewModel: function(vm) {
	    	
	    	
	    	var self = this;

	    	self.datepickerElementName = vm.datepickerElementName;
	    	
	    	self.datepickerElementId = ko.pureComputed(function() {
				return self.datepickerElementName + (vm.datepickerElementIndex ? vm.datepickerElementIndex() : '');
			})
			
			self.datepickerElementHref = ko.pureComputed(function() {
				return '#' + self.datepickerElementId();
			})
	    	
	    	self.dateDoneDisabled = vm.dateDoneDisabled;
	    	self.oneWay = vm.oneWay;
	    	self.datePickerCssClass = vm.datePickerCssClass || 'popup calendarHolder calendar-holder';
	    	self.oneWayCheckboxVisibility = vm.oneWayCheckboxVisibility === undefined ? true : vm.oneWayCheckboxVisibility;
	    		    	
	    	self.dateSelectedDone = vm.dateSelectedDone;
	    	
	    	self.datepickerFields = ko.utils.unwrapObservable(vm.datepickerFields) || {};
	    	
	    	self.routeRestrictionMessageFields = ko.utils.unwrapObservable(vm.routeRestrictionMessageFields) || { empty: true};
	    	
	    	self.datepickerFields.containerId = self.datepickerElementId();
	    	
	    	self.datepickerFields.onSelectCallback = function() {
	    		if(vm.dateChangeCallback) {
	    			vm.dateChangeCallback();
	    		}
	    	}

	    	self.atLeastOneDateSelected = ko.pureComputed( function() {
	    		return self.datepickerFields.firstDate() || self.datepickerFields.secondDate(); 
	    	});

	    	self.attrFields = vm.attrFields || {};
	    	
	    	self.chooseDateText = vm.chooseDateText || i18n.get("TextField-OB-49");
	    	
	    	self.datepickerFields.outboundSelectionNotification = vm.datepickerFields.outboundSelectionNotification || i18n.get("Label-OB-253");
	    	
	    	self.datepickerFields.inboundSelectionDirection = vm.datepickerFields.inboundSelectionDirection || i18n.get("Label-OB-254");
	    	
	    	self.datepickerFields.inboundSelectionNotification = vm.datepickerFields.inboundSelectionNotification || i18n.get("Label-OB-255");
	    	
	    	self.showPromotionLabels = ko.computed(function(){
	    		return self.datepickerFields && self.datepickerFields.promotionDates && self.datepickerFields.promotionDates() && self.datepickerFields.promotionDates().departuredateinterval_startdate ? true : false;
	    	});
	    },
	    template:
	        "<div data-bind=\"attr: { id: datepickerElementId , class: datePickerCssClass } \">\n" + 
	        "	<div class=\"row\">\n" + 
	        "		<div class=\"col-md-12\">\n" +
	        "			<div class=\"popup-wrapper\">\n" + 
	        "				<a type=\"button\" data-bind=\"togglepopup\" class=\"toogle-close-mobile-schedule toggle-popup d-block d-lg-none white\" role=\"button\" tabindex=\"0\">\n" +
	        "					<i class=\"fa fa-angle-left fs-35\"></i> \n" + 
	        "				</a>\n" + 
	        "				\n" + 
	        "				<div class=\"ui-datepicker-wrapper-header clearfix\">\n" + 
	        "					\n" + 
	        "					<h3 class=\"ui-datepicker-wrapper-title float-start schedule-title-mobile width-auto\" data-bind=\"text : chooseDateText\"></h3>\n" +
	        "					\n" + 
	        "					<div class=\"float-end mobile-pull-left\">\n" +
	        "						<!-- ko if: oneWayCheckboxVisibility --> "+
	        "						<div class=\"float-start\">\n" +
	        "							<label class=\"form-check metro-checkbox normal img-align-left\">\n" +
	        "								<input type=\"checkbox\" data-bind=\"checked:oneWay\" class=\"isOneWayTicket-component-selector-class focusable-calendar-item\" />\n" + 
	        "								<span class=\"check\"></span>\n" + 
	        "								<span class=\"check-label\" data-bind=\"i18n-text: { key: 'Checkbox-OB-01'}\"></span>\n" + 
	        "							</label>\n" + 
	        "						</div>" +
	        "			    		<!-- /ko -->\n" +	
	        "						<!-- ko if: oneWayCheckboxVisibility --> "+        
	        "						<a href=\"#clearDates\" tabindex='-1' class=\"clearDates-component-selector-class btn btn-outline-secondary disabled date-clear-btn focusable-calendar-item\">\n" +
	        "							<span class=\"d-none d-sm-block\" data-bind=\"i18n-text: { key: 'Label-OB-140'}\"></span>\n" +
	        "							<span class=\"d-block d-sm-none\">Clear</span>\n" +
	        "						</a>\n" + 
	        "			    		<!-- /ko -->\n" +
	        "						\n" + 
	        "						<a class=\"d-none d-sm-block btn btn-danger done-btn float-end toggle-popup ms-20 focusable-calendar-item\" data-bind=\"style: { 'pointer-events': atLeastOneDateSelected() ? '' : 'none' }, click: dateSelectedDone, togglepopup, i18n-text: { key: 'Label-OB-139' }, attr: { href: datepickerElementHref, disabled: dateDoneDisabled() } \"></a>\n" +
	        "						\n" + 
	        "					</div>\n" + 
	        "					\n" + 
	        "					\n" + 
	        "				</div>\n" + 
	        "				<div class=\"wrapper\">\n" + 
	        "					<div class=\"jrange-component-selector-class dates custom-datepicker\">\n" + 
	        "						<div data-bind=\"datepicker: datepickerFields \"></div>\n" + 
	        "					</div>\n" + 
	        "				</div>\n" + 
	        "			</div>\n" + 
	        "		</div>\n" + 
	        "	</div>\n" + 
	        "   <!-- ko ifnot: routeRestrictionMessageFields.empty --> " +
	        "	<div class=\"row\">\n" + 
	        "		<div class=\"col-md-12\">\n" +
	        "			<div class=\"panel-content pt-0\" id=\"routeRestrictionMessageFields\" data-bind=\"routerestrictionmessage: routeRestrictionMessageFields, attr: attrFields \"></div>\n" +
	        "		</div>\n" + 
	        "	</div>\n" + 
	        "   <!-- /ko --> " +
	        "   <!-- ko if: showPromotionLabels --> " +
	        "	<div class=\"row datepicker-promotion-labels\">\n" + 
	        "		<div class=\"col-lg-3\">\n" +
	        "			<div class=\"panel-content\">\n" +
	        "				<span class=\"bg-promotion-departure ps-5 pe-15\"></span>\n" +
	        "				<span class=\"ms-5\" data-bind=\"i18n-text: { key: 'Label-Genel-536'}\"></span>\n" +
	        "			</div>\n" +
	        "		</div>\n" +
	        "		<div class=\"col-lg-3\">\n" +
	        "			<div class=\"panel-content\">\n" +
	        "				<span class=\"bg-promotion-return ps-5 pe-15\"></span>\n" +
	        "				<span class=\"ms-5\" data-bind=\"i18n-text: { key: 'Label-Genel-537'}\"></span>\n" +
	        "			</div>\n" +
	        "		</div>\n" +
	        "	</div>\n" + 
	        "   <!-- /ko --> " +
	        "	        " + 
	        "	<a type=\"button\" data-bind=\"style: { 'pointer-events': atLeastOneDateSelected() ? '' : 'none' }, click: dateSelectedDone, togglepopup, i18n-html: { key: 'Label-OB-139' }\" class=\"schedule-done-btn toggle-popup d-block d-lg-none btn btn-danger w-100 btn-lg bold p-20 lh-normal\"></a>\n" +
	        "			" + 
	        "</div>"
	});
	
});





